import { api } from '../utils/axios';

// ========================
// DOME APIs
// ========================

/**
 * Fetch all domes with optional search and pagination
 * @param {string} search - search by domeName or location
 * @param {number} page - page number (default 1)
 * @param {number} limit - items per page (default 10)
 */
export const fetchDomes = async (search = '', page = 1, limit = 10) => {
  try {
    const response = await api.get('/dome', {
      params: { search, page, limit },
    });
    return response.data.data;
  } catch (error) {
    console.error('Error fetching domes:', error);
    throw error;
  }
};

/**
 * Fetch a single dome by ID
 */
export const fetchDomeById = async (id) => {
  try {
    const response = await api.get(`/dome/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching dome by ID:', error);
    throw error;
  }
};

/**
 * Create a new dome
 */
export const createDome = async (formData) => {
  try {
    const response = await api.post('/dome', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    });
    return response.data.data;
  } catch (error) {
    console.error('Error creating dome:', error);
    throw error;
  }
};

/**
 * Update a dome
 */
export const updateDome = async (id, formData) => {
  try {
    const response = await api.patch(`/dome/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data;
  } catch (error) {
    console.error('Error updating dome:', error);
    throw error;
  }
};

/**
 * Delete a dome
 */
export const deleteDome = async (id) => {
  try {
    const response = await api.delete(`/dome/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error deleting dome:', error);
    throw error;
  }
};

/**
 * Fetch domes by hostRef with optional domeId search and pagination
 * @param {string} hostRef - the host's ObjectId
 * @param {string} search - optional domeId search
 * @param {number} page - page number (default 1)
 * @param {number} limit - items per page (default 10)
 */
export const fetchDomesByHost = async (hostRef, search = '', page = 1, limit = 10) => {
  if (!hostRef) throw new Error("hostRef is required");

  try {
    const response = await api.get('/dome/host', {
      params: { hostRef, search, page, limit },
    });
    console.log("🚀 ~ fetchDomesByHost ~ response:", response)
    return response.data.data;
  } catch (error) {
    console.error('Error fetching domes by hostRef:', error);
    throw error;
  }
};
